import { render, staticRenderFns } from "./SettingsKh1.vue?vue&type=template&id=853557ca&lang=pug&"
import script from "./SettingsKh1.vue?vue&type=script&lang=ts&"
export * from "./SettingsKh1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports